/*
 * Copyright (c) 2005-2024, Paycheck Planner
 * All rights reserved
 * 
 */

import React, { useState } from "react";

import { useParams, useNavigate } from 'react-router-dom';
import { Row, Col, Form, Button } from "react-bootstrap";

import { useAuth, useDispatcher } from "../../components/AuthProvider"

import { MM } from "../../engine/model_manager";

import EditItemPane from "./EditItemPane";



// This routine may end up in model manager, but we will develop it out here, just
// not sure how many params we will need or if any extrapolations and equivalents will be used
function createNewItem(model, type, code, desc) {
  let item = null;

  if (type === MM.ITEMTYPE_INCOME) {
    item = MM.createNetIncome(model);
  } else if (type === MM.ITEMTYPE_EXPENSE) {
    item = MM.createExpense(model, code, desc);
  } else { // MM.ITEMTYPE_TRANSFER {
    item = MM.createTransfer(model);
  }
  return item;
}


export default function AddItem(props) {
  const dispatch = useDispatcher();
  const navigate = useNavigate();
  let { type } = useParams();
  const results = useAuth();
  const [item, setItem] = useState(null);

  const clean_type = MM.getItemTypeAsConst(type);
  const model = results.currentModel.model;


  function handleCreateItem(code, desc) {
    let new_item = createNewItem(model, clean_type, code, desc);
    setItem(new_item);
  }


  function handleAddItem(action) {
    dispatch(action);
    navigate(-1);
  }


  function handleCancel() {
    navigate(-1);
  }


  return (
    <>
      <ItemPicker type={clean_type} model={model} item={item} onSelected={handleCreateItem} onCancel={handleCancel} />
      {item !== null && <EditItemPane simModel={results.simResults.simModel} modelItem={item} itemAction='addItem' onSubmit={handleAddItem} onCancel={handleCancel} />}
    </>
  );
}


function ItemPicker(props) {
  const items = MM.populateAddItemList(props.model, props.type);

  if (props.item !== null) {
    return null;
  }


  return (
    <Row>
      <Col xs={{ span: 8, offset: 2 }}>
        <Expenses items={items} onSelected={props.onSelected} onCancel={props.onCancel} />

      </Col>
    </Row>
  );
}


function Expenses(props) {



  return (
    <>
      {props.items.map((a, i) => <Expense key={i} item={a} onSelected={props.onSelected} />)}

      <Row><Col><Button variant='danger' onClick={props.onCancel}>Cancel</Button></Col></Row>
    </>
  )
}


function Expense(props) {

  function handleSelected(event) {
    event.preventDefault();

    props.onSelected(props.item.code, props.item.desc);
  }


  let item_style = {
    textAlign: "center",
    padding: "8px",
    margin: "5px 0px 5px 0px",

    background: "	#9bedff"

  }


  return (
    <Row><Col style={item_style} ><span onClick={handleSelected}>{props.item.desc}</span></Col></Row>
  );
}



function ItemEditor(props) {

  if (props.item === null) {
    return null;
  }

  return (
    <Form>

    </Form>
  );

}